import { useHistory } from 'react-router-dom';
import { routes } from '~/constants';
import { useStore, useStoreActions } from '~/contexts';
import { useContactsMap } from '~/hooks/reactQuery/derived/useContactsMap';
import { useArchiveDraft } from '~/hooks/reactQuery/mutations/useArchiveDraft';
import { useDuplicateDraft } from '~/hooks/reactQuery/mutations/useDuplicateDraft';
import { usePreviewDraft } from '~/hooks/usePreviewDraft';
import { useScheduledProposal } from '~/hooks/useScheduledProposal';
import { useTerminateAgreement } from '~/hooks/useTerminateAgreement';
import { selectors } from '~/store/state-selectors';
export function useDraftRowActions(param) {
    let { draftId, isSample, isScheduled, refresh } = param;
    const history = useHistory();
    const { logBI } = useStoreActions();
    const { terminateDraftById } = useTerminateAgreement();
    const worksAt = useStore(selectors.user.business);
    const { contactsMap, sampleContact } = useContactsMap(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
    const { archive } = useArchiveDraft({
        onSuccess: ()=>refresh()
    });
    const { duplicateDraft } = useDuplicateDraft({
        onSuccess: (newDraftId)=>history.push(routes.draft(newDraftId))
    });
    const { previewDraft } = usePreviewDraft({
        sampleContact,
        contactsMap
    });
    const { sendNow, cancelScheduledProposal, showSwitchToEditModal } = useScheduledProposal({
        draftId,
        refresh,
        isSampleRelationship: isSample
    });
    return {
        onEdit: ()=>{
            if (isScheduled) {
                showSwitchToEditModal();
            } else {
                logBI(10352);
                history.push(routes.draft(draftId));
            }
        },
        onPreview: ()=>previewDraft(draftId),
        onSendNow: sendNow,
        onCancelScheduling: cancelScheduledProposal,
        onDuplicate: ()=>duplicateDraft(draftId),
        onArchive: ()=>{
            logBI(18800);
            archive(draftId);
        },
        onDelete: ()=>terminateDraftById(draftId, ()=>refresh()),
        showSwitchToEditModal
    };
}
